"use client";

import Image from "next/image";
import Link from "next/link";

const Footer = () => {
  // ==========================
  // JSON DATA
  // ==========================
  const footerData = {
    sections: [
      {
        title: "राज्य और विषय",
        links: [
          {
            title: "महाराष्ट्र समाचार",
            path: "/state/maharashtra-news/",
          },
          {
            title: "दिल्ली समाचार",
            path: "/state/delhi-news/",
          },
          {
            title: "बिहार न्यूज़",
            path: "/state/bihar-news-in-hindi/",
          },
          {
            title: "झारखंड समाचार",
            path: "/state/jharkhand-news/",
          },
          {
            title: "छत्तीसगढ़ समाचार",
            path: "/state/chhattisgarh-news-in-hindi/",
          },
          {
            title: "पश्चिम बंगाल",
            path: "/state/west-bengal",
          },
          {
            title: "उत्तर प्रदेश",
            path: "/state/uttar-pradesh",
          },
          { title: "उत्तराखंड", path: "/state/uttarakhand" },

          {
            title: "बिजनेस न्यूज़",
            path: "/business-news/",
          },
          {
            title: "राष्ट्रीय समाचार",
            path: "/national-news-updates/",
          },
          {
            title: "लाइफस्टाइल",
            path: "/life-and-style-news/",
          },
          {
            title: "धर्म समाचार",
            path: "/religion-news-insights/",
          },
          {
            title: "खेल समाचार",
            path: "/latest-sports-news-hindi/",
          },

          { title: "दुनिया", path: "/world/" },
          {
            title: "मनोरंजन",
            path: "/entertainment-updates/",
          },
          {
            title: "ट्रेक",
            path: "/latest-tech-news/",
          },
        ],
      },
      {
        title: "OTHER LINKS",
        links: [
          {
            title: "Mission Statement",
            path: "/policies-and-standards/#MS",
          },
          {
            title: "How our Journalists work",
            path: "/policies-and-standards/#HOJW",
          },
          {
            title: "Diverse Voices Statement",
            path: "/policies-and-standards/#DVS",
          },
          {
            title: "Ethics Policy",
            path: "/policies-and-standards/#EP",
          },
          {
            title: "Message from the Editor",
            path: "/policies-and-standards/#MFTE",
          },
          {
            title: "Corrections Policy",
            path: "/policies-and-standards/#CP",
          },
          {
            title: "Diverse Staffing and Policy",
            path: "/policies-and-standards/#DSAP",
          },
          {
            title: "Privacy Policy",
            path: "/privacy-policy/",
          },
          {
            title: "Our Business",
            path: "/policies-and-standards/#OB",
          },
          {
            title: "Coverage Priorities",
            path: "/policies-and-standards/#CPr",
          },
          {
            title: "Anonymous Sources Policy",
            path: "/policies-and-standards/#ASP",
          },
          {
            title: "Disclaimer",
            path: "/disclaimer/",
          },
          { title: "Contact Us", path: "/contact" },
          { title: "About Us", path: "/about/" },
        ],
      },
    ],

    socialIcons: [
      {
        Icon: () => (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            version="1.2"
            baseProfile="tiny"
            viewBox="0 0 24 24"
            height="1.4em"
            width="1.4em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M13 10h3v3h-3v7h-3v-7h-3v-3h3v-1.255c0-1.189.374-2.691 1.118-3.512.744-.823 1.673-1.233 2.786-1.233h2.096v3h-2.1c-.498 0-.9.402-.9.899v2.101z"></path>
          </svg>
        ),
        label: "Facebook",
        path: "https://www.facebook.com/RashtraBharatdigital/",
      },

      {
        Icon: () => (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            height="1.1em"
            width="1.1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17.6874 3.0625L12.6907 8.77425L8.37045 3.0625H2.11328L9.58961 12.8387L2.50378 20.9375H5.53795L11.0068 14.6886L15.7863 20.9375H21.8885L14.095 10.6342L20.7198 3.0625H17.6874ZM16.6232 19.1225L5.65436 4.78217H7.45745L18.3034 19.1225H16.6232Z"></path>
          </svg>
        ),
        label: "X",
        path: "https://x.com/RBharatdigital",
      },

      {
        Icon: () => (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 16 16"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"></path>
          </svg>
        ),
        label: "Instagram",
        path: "https://www.instagram.com/rashtrabharatdigital/",
      },

      {
        Icon: () => (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 256 256"
            height="1.3em"
            width="1.3em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M188.84,120.46a68.14,68.14,0,0,0-10-6.23c-3.72-21.68-16.41-37.41-35.52-43.2C121.94,64.55,97.29,72.42,86,89.34a12,12,0,0,0,20,13.32c5.47-8.2,19.11-12.08,30.41-8.66a24.72,24.72,0,0,1,14.88,12.24,86.73,86.73,0,0,0-8.86-.45C108.56,105.79,84,125.22,84,152c0,22.9,17.54,39.52,41.71,39.52a52,52,0,0,0,37.23-16c6-6.23,12.88-16.46,15.72-32.07,6.2,6.42,9.34,14.67,9.34,24.59,0,17.74-19.07,44-60,44-45.76,0-68-27.48-68-84s22.24-84,68-84c31.08,0,51,12.42,60.8,38a12,12,0,0,0,22.4-8.62C197.77,38.44,169,20,128,20,68.67,20,36,58.35,36,128s32.67,108,92,108c31.36,0,51.08-12.05,62.11-22.15C203.81,201.28,212,184.14,212,168,212,148.36,204,131.92,188.84,120.46Zm-43.2,38.39a27.9,27.9,0,0,1-19.93,8.67c-8.17,0-17.71-4.06-17.71-15.52,0-15.26,17.84-22.21,34.41-22.21a60.23,60.23,0,0,1,13.51,1.52C155.36,142.93,151.84,152.41,145.64,158.85Z"></path>
          </svg>
        ),
        label: "Threads",
        path: "https://www.threads.com/@rashtrabharatdigital",
      },

      {
        Icon: () => (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 448 512"
            height="1.2em"
            width="1.2em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
          </svg>
        ),
        label: "LinkedIn",
        path: "https://www.linkedin.com/company/rashtrabharatdigital/",
      },

      {
        Icon: () => (
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
          </svg>
        ),
        label: "YouTube",
        path: "https://www.youtube.com/@RashtraBharatdigital",
      },

      {
        Icon: () => (
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
          </svg>
        ),
        label: "Email",
        path: "mailto:info@rashtrabharat.com",
      },
    ],

    legal: {
      dnpa: "DNPA's code of conduct",
      email: "grievance@rashtrabharat.com",
      copyright: `© ${new Date().getFullYear()} Rashtra Bharat`,
      ctpl: "(CTPL)",
    },

    brand: {
      title: "राष्ट्रभारत",
      website: "www.rashtrabharat.com",
    },
  };

  // ==========================
  // COMPONENT JSX
  // ==========================
  return (
    <footer className="bg-black text-white">
      {/* Desktop */}
      <div className=" px-5 lg:px-16 py-12">
        <div className="container">
          {/* Sections */}
          <div className="grid grid-cols-1  lg:grid-cols-2  gap-10 mb-8">
            {footerData.sections.map((sec) => (
              <div key={sec.title}>
                <h3 className="text-md font-bold mb-4">{sec.title}</h3>

                {/* Links — 2 column on mobile, 2 column tablet, 1 column desktop */}
                <div className="grid grid-cols-1  lg:grid-cols-2 gap-y-2 gap-x-6">
                  {sec.links.map((item) => (
                    <Link
                      key={item?.path}
                      href={item.path}
                      className="text-gray-300 hover:text-white text-sm transition-colors"
                    >
                      {item.title}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="border-t border-gray-800 mb-8"></div>

          {/* Brand + Social */}
          <div className="flex items-center gap-8 mb-8 flex-wrap">
            <div className="bg-white  rounded">
              <Image
                src="/RB-Logo.png"
                width={103}
                height={50}
                alt="Rashtra Bharat Logo"
              />
            </div>

            <div className="flex items-center gap-4">
              <span className="text-[#ccc] text-sm">FOLLOW US ON</span>

              <div className="flex items-center gap-2">
                {footerData?.socialIcons.map((social, index) => (
                  <Link
                    key={index}
                    href={social.path}
                    target="_blank"
                    className="text-[#ccc]"
                    aria-label={social.label}
                  >
                    <social.Icon />
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* Legal */}
          <div className="text-sm text-white space-y-2">
            <p>
              This website follows the{" "}
              <Link
                href="/code-of-ethics-for-digital-news-websites"
                className="text-yellow-500 hover:underline"
              >
                {footerData.legal.dnpa}
              </Link>
              . For any feedback or complaint email to{" "}
              <Link
                href={`mailto:${footerData.legal.email}`}
                className="text-[#f1c40f] hover:underline"
              >
                {footerData.legal.email}
              </Link>
            </p>

            <p>
              In case of any data protection questions, please reach out to{" "}
              <Link
                href={`mailto:${footerData.legal.email}`}
                className="text-[#f1c40f] hover:underline"
              >
                {footerData.legal.email}
              </Link>
            </p>

            <div className="flex gap-2">
              <p>{footerData.legal.copyright}</p>
              <Link
                href="https://cybertizeweb.com/"
                className="text-[#f1c40f] hover:underline"
              >
                {footerData.legal.ctpl}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
